module.exports = __webpack_public_path__ + "img/Male_Anterior_Abdomen.274a7c62.png";